import { H6 } from '../../../../theme';

type TitleProps = {
    title: string;
};

export const Title = ({ title }: TitleProps): JSX.Element => {
    return <H6>{title}</H6>;
};
